import { defineStore } from 'pinia'
import { ref, shallowRef } from 'vue'
import { systemApi, type SystemCodeDto } from '@/api/system' // 記得去 systemApi 補上 getAllDropdowns

export const useDictionaryStore = defineStore('dictionary', () => {
  // 存放所有字典資料的響應式物件
  const dictData = shallowRef<Record<string, SystemCodeDto[]>>({})
  // 紀錄是否已經抓取過，避免重複打 API
  const isLoaded = ref(false)
  let fetchPromise: Promise<void> | null = null

  const fetchAll = async () => {
    if (isLoaded.value) return
    if (fetchPromise) return fetchPromise

    fetchPromise = (async () => {
      try {
        const response = await systemApi.getAllDropdowns()
        dictData.value = (response as unknown as Record<string, SystemCodeDto[]>) || {}
        isLoaded.value = true
      } catch (error) {
        dictData.value = {}
      }
    })()

    try {
      await fetchPromise
    } finally {
      fetchPromise = null
    }
  }

  // 提供給元件使用的 Getter 工具
  const getOptions = (category: string) => {
    // 🌟 加上 ?. 保護機制。意思是：如果 dictData.value 是 undefined，就直接回傳 []，不要報錯！
    return dictData.value?.[category] || []
  }

  return { dictData, isLoaded, fetchAll, getOptions }
})
